import React from 'react';
import PropTypes from 'prop-types';

import InlineSVG from 'svg-inline-react';
import menu from '../../assets/images/menu.svg';

const MenuButton = ({ openMenu }) => {
    return (
        <button type="button" onClick={openMenu} className='dashboard-menu-button'>
            <InlineSVG className='dashboard-menu-icon' src={menu} />
            <div className='dashboard-menu-text'>Menu</div>
        </button>
    );
};

MenuButton.defaultProps = {
    openMenu: () => {},
};

MenuButton.propTypes = {
    openMenu: PropTypes.func,
};

export default MenuButton;
